import { render, staticRenderFns } from "./admin_login.vue?vue&type=template&id=3bd766fd"
import script from "./admin_login.vue?vue&type=script&lang=js"
export * from "./admin_login.vue?vue&type=script&lang=js"
import style0 from "./admin_login.vue?vue&type=style&index=0&id=3bd766fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports